export const ENUM_STATUS_GAME = {
    READY       : "READY",
    SETUP       : "SETUP",
    BEGIN       : "BEGIN",
    SET_SHADOW  : "SET_SHADOW",
    GET_SHADOW  : "GET_SHADOW",
    GET_RESULTS : "GET_RESULTS"
}

export const NAME_DOCUMENT_FOR_USER = "user"
export const NAME_DOCUMENT_FOR_ROOM = "room"
export const NAME_DOCUMENT_FOR_GAME_INFOR = "game_infor"

export const KEY_STORAGE_FOR_USER = "KEY_STORAGE_FOR_USER"

export const LIST_SHADOW_INDEX = [1, 2, 3, 4, 5, 6, 7]

export const LIST_COMMON_SHADOW = [
    {
        title        : "Tổng vệ sinh lớn ăn",
        indexes      : [0 , 1 , 2 , 3 , 4 , 5 , 6],
        isBiggestNum : true
    },
    {
        title        : "Tổng vệ sinh bé ăn",
        indexes      : [0 , 1 , 2 , 3 , 4 , 5 , 6],
        isBiggestNum : false
    },
    {
        title        : "1 Đầu 1 đít lớn ăn",
        indexes      : [0, 6],
        isBiggestNum : true
    },
    {
        title        : "1 Đầu 1 đít bé ăn",
        indexes      : [0, 6],
        isBiggestNum : false
    },
    {
        title        : "3 đầu lớn ăn",
        indexes      : [0, 1, 2],
        isBiggestNum : true
    },
    {
        title        : "2 4 6 lớn ăn",
        indexes      : [1, 3, 5],
        isBiggestNum : true
    },
    {
        title        : "1 đầu 2 đít lớn ăn",
        indexes      : [0, 5, 6],
        isBiggestNum : true
    },
    {
        title        : "1 đầu 1 giữa 1 đít lớn ăn",
        indexes      : [0, 3, 6],
        isBiggestNum : true
    }
]